module.exports = __webpack_public_path__ + "img/mesa_el_q.eae61a67.png";